<template>
  <TWModal
    :title="$t('envelope.resendEnvelope')"
    :loading="loading"
    :show="show"
    @close="closeModal">
    <template v-slot:content>
      <div class="max-h-96 overflow-auto">
        <div v-if="envelope.is_parallel_signing_enabled">
          <p>{{ $t('envelope.parallelWarning') }}</p>
          <CheckboxInput
            v-model="selectEveryone"
            @change="onEveryoneUpdated"
            data-ec="envelope_resend_now_modal"
            data-et="resend_to_everyone"
            :label="$t('envelope.resendNowToEveryone')"
          />
          <hr/>
          <p>{{ $t('envelope.resendNowToSpecificPeople') }}:</p>
          <div v-for="party in parties" :key="party.id" class="mb-1">
            <CheckboxInput
              v-model="party.selected"
              @change="onPartyUpdated"
              data-ec="envelope_resend_now_modal"
              data-et="resend_to_specific_party"
              :label="`${party.title} (${party.email})`"
            />
          </div>
        </div>
        <p v-else>{{ $t('envelope.resendNowWarning') }}</p>
      </div>
    </template>

    <template v-slot:controls>
      <BaseButton
        variant="invisible"
        @click.native="closeModal"
        data-ec="envelope_resend_now_modal"
        data-et="btn_cancel"
      >
        {{ $t('functional.cancel') }}
      </BaseButton>

      <BaseButton
        @click.native="resend"
        :disabled="buttonDisabled"
        data-ec="envelope_resend_now_modal"
        data-et="resend_now_button"
      >
        {{ $t('envelope.resendNow') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import CheckboxInput from '@/components/library/inputs/CheckboxInput.vue';

export default {
  name: 'EnvelopeResendNowModal',
  components: {
    TWModal,
    CheckboxInput,
    BaseButton,
  },
  data() {
    return {
      loading: false,
      parties: [],
      selectEveryone: true,
      buttonDisabled: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    envelope: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.parties = [];
      this.$emit('close');
    },
    async resend() {
      this.loading = true;
      let parties = [];

      if (!this.selectEveryone) {
        parties = this.parties
          .filter(party => party.selected)
          .map(party => party.id);
      }
      try {
        await this.$store.dispatch('envelopes/SEND_ONE_OFF_REMINDER', {
          fingerprint: this.envelope.fingerprint,
          parties,
        });
      } finally {
        this.$emit('close');
        this.loading = false;
      }
    },
    onEveryoneUpdated(checked) {
      this.parties.forEach((party) => {
        this.$set(party, 'selected', checked);
      });

      this.updateButtonVisibility();
    },
    onPartyUpdated() {
      this.selectEveryone = this.parties.every(party => party.selected);
      this.updateButtonVisibility();
    },
    updateButtonVisibility() {
      this.buttonDisabled = !this.selectEveryone && this.parties.filter(party => party.selected).length === 0;
    },
    initParties() {
      if (!this.envelope.parties) {
        return;
      }

      this.parties = this.envelope.parties
        .filter(party => !party.status.action_performed_date && party.status.sent)
        .map((party) => {
          if (!('selected' in party)) {
            return { ...party, selected: true };
          }

          return party;
        });

      this.onPartyUpdated();
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.initParties();
      }
    },
  },
  mounted() {
    this.initParties();
  },
};
</script>
<style lang="scss" scoped>
.disabled {
  @apply pointer-events-none bg-disabledGrey
}
</style>
